import { Grid, Stack, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { H1, H2, SECONDARY_MAIN } from "../../../Constants/CommonConstants";
import {
  ACCOUNT_TYPE_SITE_CERTIFIER,
  PROVIDER_ACCOUNT_DESC,
  PROVIDER_ACCOUNT_HEADER,
  PROVIDER_ACCOUNT_PROVIDER_STAFF_HEADER,
  PROVIDER_ACCOUNT_SITE_CERTIFIER_HEADER,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { getProvider } from "../../../Features/ProviderAccountCreationSlice";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { StyledProviderAccountCreationBox } from "../../../Styles/ProviderAndCertifierAccountCreation/ProviderAccountCreationStyles";
import { AccountCreationForm } from "./AccountCreationForm";
import { PersonalInformation } from "./PersonalInformation";
import {
  fetchUserRoleByValue,
  transformProviderSiteList,
} from "../../../Services/CommonServices";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";
import { SiteInformation } from "react-common-ui-library";

/**
 * @description Provider account creation parent component.
 * @returns {ReactNode} Renders the provider account creation heading, personal information component and form component
 */
const AccountCreationWrapper = () => {
  const intl = useIntl();

  const dispatch = useDispatch();

  const { userInvitationId, accountType, siteDetails } = useSelector((state) =>
    manageProviderAccountCreationSelector(state)
  );

  const { userRole } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  const userRoleValue = useMemo(() => {
    return fetchUserRoleByValue(userRole, accountType);
  }, [accountType, userRole]);

  useEffect(() => {
    dispatch(getProvider(userInvitationId));
  }, [dispatch, userInvitationId]);

  return (
    <Grid container columnSpacing={7}>
      <Grid item xs={12} md={4}>
        {siteDetails.length > 0 && (
          <SiteInformation
            siteLocationList={transformProviderSiteList(siteDetails)}
          />
        )}
      </Grid>
      <Grid item xs={12} md={8}>
        <StyledProviderAccountCreationBox>
          <Stack spacing={5}>
            <Stack spacing={3}>
              <Typography
                component={H1}
                variant={H2}
                color={SECONDARY_MAIN}
                id={PROVIDER_ACCOUNT_HEADER}
              >
                {accountType
                  ? intl.formatMessage({
                      id:
                        userRoleValue?.valueText === ACCOUNT_TYPE_SITE_CERTIFIER
                          ? PROVIDER_ACCOUNT_SITE_CERTIFIER_HEADER
                          : PROVIDER_ACCOUNT_PROVIDER_STAFF_HEADER,
                    })
                  : null}
              </Typography>
              <Typography id={PROVIDER_ACCOUNT_DESC}>
                {intl.formatMessage({ id: PROVIDER_ACCOUNT_DESC })}
              </Typography>
            </Stack>
            <PersonalInformation />
            <AccountCreationForm />
          </Stack>
        </StyledProviderAccountCreationBox>
      </Grid>
    </Grid>
  );
};

export default AccountCreationWrapper;
